'use client'

import { useCallback } from 'react'
import { useTransitionEndEffect } from '@/src/hooks/use-transition-end-effect'
import { usePortfolioDrawer } from '@/src/stores/portfolio-drawer/actions'
import { cn } from '@/src/utils/styles'
import { PortfolioScreen } from './portfolio-screen'

export function PortfolioDrawer() {
  const { isOpen, setShouldHideBalances } = usePortfolioDrawer()

  const handleTransitionEnd = useCallback(
    (e: TransitionEvent) => {
      // Only proceed if this is the transform transition and drawer is closed
      if (!isOpen && e.propertyName === 'transform') {
        setShouldHideBalances(true)
      }
    },
    [isOpen, setShouldHideBalances],
  )

  const drawerRef = useTransitionEndEffect(handleTransitionEnd)

  // Hydrate user atom for child component use in portfolio drawer
  // If you want to use the user atom in other parts of the app in the current route, you
  // may need to lift the hydration to a wrapper 'use client' component.
  return (
    <div
      ref={drawerRef}
      className={cn(
        'portfolio-drawer fixed right-0 top-0 z-30 w-full h-full max-w-portfolio-width opacity-0 translate-x-full overflow-auto overscroll-contain no-scrollbar bg-background sm:border-l flex flex-col transition-all duration-500 ease-default',
        {
          'translate-x-0 opacity-100 border-l-border1': isOpen,
        },
      )}
      data-is-drawer-open={isOpen}
    >
      <PortfolioScreen />
    </div>
  )
}
